import {EnsAlertType} from "../../../store/features/ens/types";
import {TYPE_DOT_COLOR, TYPE_LABEL} from "../utils";

const STYLE: Record<EnsAlertType, string> = {
    FRAUD: 'border-[#f59e0b] bg-[#fff7ed] text-[#b45309]',
    TASK: 'border-[#22c55e] bg-[#f0fdf4] text-[#15803d]',
    POLICY: 'border-[#3b82f6] bg-[#eff6ff] text-[#1d4ed8]',
    CUSTOM: 'border-[#7c3aed] bg-[#faf5ff] text-[#6d28d9]',
};

const TEXT_COLOR: Record<EnsAlertType, string> = {
    FRAUD: 'text-[#b45309]',
    TASK: 'text-[#15803d]',
    POLICY: 'text-[#1d4ed8]',
    CUSTOM: 'text-[#6d28d9]',
};

interface Props {
    type: EnsAlertType;
    size?: 'sm' | 'md' | 'lg';
    variant?: 'pill' | 'text' | 'dotText';
    className?: string;
}

const SIZE: Record<NonNullable<Props['size']>, string> = {
    sm: 'h-5 px-2 text-[11px]',
    md: 'h-7 px-3 text-xs',
    lg: 'h-8 px-3 text-sm',
};

export const TypeBadge = ({type, size = 'sm', variant = 'pill', className = ''}: Props) => {
    if (variant === 'text') {
        return (
            <span className={`inline-flex items-center text-xs font-semibold ${TEXT_COLOR[type]} ${className}`}>
                {TYPE_LABEL[type]}
            </span>
        );
    }
    if (variant === 'dotText') {
        return (
            <span className={`inline-flex items-center gap-2 text-sm font-semibold ${TEXT_COLOR[type]} ${className}`}>
                <span className={`h-2 w-2 rounded-full ${TYPE_DOT_COLOR[type]}`}/>
                {TYPE_LABEL[type]}
            </span>
        );
    }
    return (
        <span
            className={`inline-flex shrink-0 items-center justify-center rounded-full border font-semibold leading-none whitespace-nowrap ${STYLE[type]} ${SIZE[size]} ${className}`}
        >
            {TYPE_LABEL[type]}
        </span>
    );
};
